import { makeActionCreator } from '../../../utilities'
import { ZipConstants } from './zip.constants'

export const setZipState = makeActionCreator(ZipConstants.SET_ZIP_STATE, 'zipCode', 'cityAction', 'stateAction')
export const setZipResponse = makeActionCreator(ZipConstants.SET_ZIP_RESPONSE, 'zip')
export const setAlertMessage = makeActionCreator(ZipConstants.SET_ALERT_MESSAGE, 'alertMessage')
